import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTable, { StatusPill, fmtCurrency, fmtDate } from "../components/DataTable";
import { apiCall } from "../auth/AuthContext";

export default function AdminGrants() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const d = await apiCall("/api/admin/grants"); setRecords(d.records || []); }
      catch { setRecords([]); }
      finally { setLoading(false); }
    })();
  }, []);

  const columns = [
    { key: "Name", label: "Client", sortable: true },
    { key: "Grant Name", label: "Grant" },
    { key: "Grantor", label: "Grantor" },
    { key: "Amount Applied For", label: "Applied", fmt: fmtCurrency },
    { key: "Application Deadline", label: "Deadline", fmt: fmtDate, sortable: true },
    {
      key: "Days Until Deadline", label: "Days",
      fmt: (v) => typeof v === "number" ? (
        <span className={v < 14 && v >= 0 ? "text-red-300 font-semibold" : v < 0 ? "text-red-400" : "text-jc-white"}>{v}</span>
      ) : "—"
    },
    { key: "Status", label: "Status", fmt: (v) => <StatusPill value={v} tone={(v || "").toLowerCase() === "awarded" ? "success" : "info"} /> },
  ];

  return (
    <AdminLayout title="GRANT TRACKER" kicker="Open Applications">
      <DataTable
        testId="admin-grants-table"
        loading={loading}
        records={records}
        columns={columns}
        searchKeys={["Name", "Grant Name", "Grantor", "Status"]}
        emptyText="No grant applications yet."
        initialSort={{ key: "Application Deadline", dir: "asc" }}
      />
    </AdminLayout>
  );
}
